import { useEffect, useState } from 'react'
import { isMobile, isTablet } from 'react-device-detect'

export interface UseDeviceDetectReturnValue {
  isMobile: boolean
  isTablet: boolean
}

export const useDeviceDetect = (): UseDeviceDetectReturnValue => {
  const [isDeviceMobile, setIsDeviceMobile] = useState(false)
  const [isDeviceTablet, setIsDeviceTablet] = useState(false)

  useEffect(() => {
    if (window) {
      setIsDeviceMobile(isMobile)
      setIsDeviceTablet(isTablet)
    }
  }, [])

  return {
    isMobile: isDeviceMobile,
    isTablet: isDeviceTablet,
  }
}
